/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Return_New_Lot_ForcedInputs */

const vi_confirm_return_new_lot_forced = /** @type {(inputs: Confirm_Return_New_Lot_ForcedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khác kệ của lô → tạo lô mới cùng mã`)
};

/**

* @param {Confirm_Return_New_Lot_ForcedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_new_lot_forced = /** @type {((inputs?: Confirm_Return_New_Lot_ForcedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_New_Lot_ForcedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_new_lot_forced(inputs)
});